module.exports = __webpack_public_path__ + "static/media/correct.43149f74.png";